export const dispatchShowAlertChanges = (showChangesAlert) => {
	document.querySelector("#react-root").dispatchEvent(new CustomEvent("showChangesAlert", {
		detail:{
			showChangesAlert: showChangesAlert ,
		}
	}));
}